// give jump link "active" class when scrolling and change the accordion heading text content
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".jump-links a.scroll-to");
  const jumpLinkAcc = document.querySelector(".jump-link-accordion");
  const jumpLinkAccBtn = document.querySelector(".jump-link-accordion-button");
  const jumpLinkAccPanel = document.querySelector(".jump-link-accordion-panel");
  const jumpLinkHeading = document.querySelector(".jump-link-heading");
  const jumpLinksHolder = document.querySelector(".jump-link-holder");
  const bodySection = document.querySelector(".site-content");
  const bottomSection = document.querySelector(".related-content");

  if (links.length !== 0 || jumpLinkHeading) {
      // Map links to their target elements
      const targets = Array.from(links).map(link => {
      const id = link.getAttribute("href").substring(1);
      return document.getElementById(id);
    });

    function updateActiveLink() {
      let indexToActivate = null;

      for (let i = 0; i < targets.length; i++) {
        const target = targets[i];
        if (!target) continue;

        const rect = target.getBoundingClientRect();
        if (rect.top <= 100) {
          indexToActivate = i;
        }
      }

      links.forEach(link => {
        link.parentElement.classList.remove("active");
        link.removeAttribute("aria-current");

        link.addEventListener("click", () => {
          // Close accordion
          jumpLinkAcc.classList.add("closed");
          jumpLinkAccBtn.setAttribute("aria-expanded", "false");
          jumpLinkAccPanel.style.display = "none";
        });
      });

      if (indexToActivate !== null) {
        const activeLink = links[indexToActivate];
        activeLink.parentElement.classList.add("active");
        activeLink.setAttribute("aria-current", "location");

        // jump link button heading text change
        // Only update heading text if screen is under 981px
        /**
          if (window.innerWidth <= 980) {
            jumpLinkHeading.textContent = activeLink.textContent;
          }
        */
      } else {
        // jump link button heading text change
        /**
          if (window.innerWidth <= 980) {
            jumpLinkHeading.textContent = "On this page";
          }
        */
      }
    }

    window.addEventListener("scroll", updateActiveLink);
    updateActiveLink(); // Initial update

    // jump link button heading text change
    /**
      if (jumpLinkAccBtn && jumpLinkHeading) {
        jumpLinkAccBtn.addEventListener("click", () => {
          const isExpanded = jumpLinkAccBtn.getAttribute("aria-expanded") === "true";
          // If accordion is now opened, reset heading to "Contents"
          if (!isExpanded) {
            jumpLinkHeading.textContent = "On this page";
          }
        });
      }
    */
  };

  // sticky jump links
  if (!jumpLinksHolder) return;

  let lastScrollY = window.scrollY;

  window.addEventListener("scroll", function () {
    const scrollY = window.scrollY;
    const sectionTop = bodySection.offsetTop;
    const jumpLinksHolderHeight = jumpLinksHolder.offsetHeight;
    const bottomSectionTop = bottomSection.offsetTop;
    const sectionBottom = bottomSectionTop - jumpLinksHolderHeight;
    const scrollingDown = scrollY > lastScrollY;

    if (scrollY >= sectionTop && scrollY < sectionBottom) {
      // In safe zone
      jumpLinksHolder.classList.add("fixed-jump-links");
      jumpLinksHolder.classList.remove("absolute-jump-links");
      jumpLinksHolder.style.top = "0px";

    } else if (scrollY >= sectionBottom) {
      if (scrollingDown) {
        // Hit bottomSection going down — pin just above bottomSection
        jumpLinksHolder.classList.remove("fixed-jump-links");
        jumpLinksHolder.classList.add("absolute-jump-links");
        jumpLinksHolder.style.top = sectionBottom + "px";
      } else {
        // Re-entered the safe zone from bottom
        if (scrollY < sectionBottom) {
          jumpLinksHolder.classList.add("fixed-jump-links");
          jumpLinksHolder.classList.remove("absolute-jump-links");
          jumpLinksHolder.style.top = "0px";
        }
      }

    } else {
      // Above article section — remove styles
      jumpLinksHolder.classList.remove("fixed-jump-links", "absolute-jump-links");
      jumpLinksHolder.style.top = "";
    }

    lastScrollY = scrollY;
  });
});